var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9463 48.3848H11.6074V10.4055H40.9463V48.3848Z",
    fill: "#B5CEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3916 45.5945L20.2579 41.2886C17.2479 40.7515 15.0527 38.0977 15.0527 34.9957V7.61523H44.3916V45.5945Z",
    fill: "#E9F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3398 7.61523V44.8716L44.3913 45.5945V7.61523H40.3398Z",
    fill: "#DEEBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4121 41.2944L44.3915 45.5944L25.7481 34.0936C25.7481 34.0937 25.9966 41.2944 20.4121 41.2944Z",
    fill: "#91A8DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45.5945V7.61523C45 7.27546 44.7279 7 44.3923 7H15.0534C14.7178 7 14.4457 7.27546 14.4457 7.61523V9.79029H11.6077C11.2721 9.79029 11 10.0658 11 10.4055V15.778C11 16.5735 12.2154 16.5735 12.2154 15.778V11.0208H14.4457V34.9957C14.4457 38.403 16.846 41.3044 20.1531 41.8945L40.3389 45.496V47.7695H12.2154V19.2682C12.2154 18.4727 11 18.4727 11 19.2682V48.3848C11 48.7245 11.2721 49 11.6077 49H40.9466C41.2822 49 41.5543 48.7245 41.5543 48.3848V45.7128L44.2869 46.2004C44.5532 46.2479 45 46.0742 45 45.5945ZM15.6611 34.9957V8.23047H43.7846V44.4991L31.7066 37.0485C31.0356 36.6346 30.4031 37.6853 31.0741 38.0993L41.3243 44.4224L23.2298 41.194C25.2929 39.9803 26.1237 37.4434 26.3172 35.1647L28.3143 36.3967C28.9854 36.8105 29.6178 35.7598 28.9468 35.3459L26.0652 33.5683C25.543 33.3787 25.2351 33.5608 25.1416 34.1144C25.2448 37.3462 23.0033 41.1249 20.3602 40.6819C17.632 40.2245 15.6611 37.8034 15.6611 34.9957Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 14.4625H38.9975C39.8022 14.4343 39.8015 13.26 38.9975 13.2321H20.447C19.6424 13.2603 19.6429 14.4346 20.447 14.4625Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 18.2559H38.9975C39.8022 18.2276 39.8015 17.0534 38.9975 17.0254H20.447C19.6424 17.0537 19.6429 18.228 20.447 18.2559Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 22.0493H38.9975C39.8022 22.0211 39.8015 20.8468 38.9975 20.8188H20.447C19.6424 20.8471 19.6429 22.0213 20.447 22.0493Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.447 25.8427H38.9975C39.8022 25.8144 39.8015 24.6402 38.9975 24.6122H20.447C19.6424 24.6404 19.6429 25.8147 20.447 25.8427Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs-icon.7ca8d4c9592981b04336d1be351ec63c.svg";
export { ForwardRef as ReactComponent };